import React from 'react';
import styled from 'styled-components';
import {GridContainer, CenteredGrid, GridItem} from './GridContainer';

const DebugContainer = styled.div`
    position: fixed;
    z-index: 9999;
    height: 100%;
    width: 100%;
    opacity: 0.5;
    &.hidden-grid {
        visibility: hidden;
    }
    .ue-grid-container {
        background-color: grey;
    }
`;

const Box = styled.div`
    width: 100%;
    height: 100vh;
    background-color: white;
    color: black;
    text-align: center;
    padding-top: 1em;
`;

interface GridDebugProps {
    hidden?: boolean;
}

export const GridDebug = (props: GridDebugProps): JSX.Element | null => {
    const {hidden} = props;

    const items: React.ReactElement<any>[] = [];
    for (let i = 0; i < 12; i++) {
        items.push(
            <GridItem id={`grid-item-${i}`} key={`grid-item-${i}`}>
                <Box>{i + 1}</Box>
            </GridItem>
        );
    }

    return (
        <DebugContainer className={`${hidden ? 'hidden-grid' : ''} ue-debug-grid-container`}>
            <GridContainer>
                <CenteredGrid>{items}</CenteredGrid>
            </GridContainer>
        </DebugContainer>
    );
};
